/**
 * Walk up from `node` and return the nearest ancestor that actually scrolls
 * vertically (`overflow-y: auto | scroll`), or `null` if there is none.
 *
 * Used to window a virtualized list against a surrounding scroll container
 * (e.g. a drawer body) and to preserve that container's scroll position across
 * subtree swaps.
 */
export const getScrollableAncestor = (node: Element | null): Element | null => {
  let el = node?.parentElement ?? null;
  while (el) {
    const overflowY = getComputedStyle(el).overflowY;
    if (overflowY === 'auto' || overflowY === 'scroll') return el;
    el = el.parentElement;
  }
  return null;
};
